/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ['Adicionar "', ["inputValue"], '"'],
    "All items have been removed.": "Todos os itens foram removidos.",
    "Clear selection": "Limpar seleção",
    "No results found.": "Não foram encontrados resultados.",
    "Select All": "Selecionar tudo",
    "Selected Items": "Itens selecionados",
    "Toggle menu": "Alternar menu",
    "listbox contents": "conteúdo da caixa de listagem",
    "{itemAsString} has been removed.": [["itemAsString"], " foi removido."],
    "{itemAsString} has been selected.": [["itemAsString"], " foi selecionado."],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            ["resultCount", "plural", { one: ["#", " o resultado é"], other: ["#", " os resultados são"] }],
            " disponível, use as teclas de seta para cima e para baixo para navegar. Pressione a tecla Enter para selecionar.",
        ],
    "{selectedValue} selected": [["selectedValue"], " selecionado"],
};
